import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import _ from 'lodash';
import moment from 'moment';

import { canonicalLink } from 'utils/seoUtils';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { isoDate, localDateShort, localFullDateLong } from 'utils/LocalDateTimeHelper';
import { loadMatches, resetMatchesLoaded } from '../reducers/dailyMatches';
import { load as loadCompetitions } from '../reducers/competitions';
import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';
import FootballLiveCompetitionList from '../components/FootballLiveCompetitionList';
import FootballMyScores from "./FootballMyScores";
import Tabs from 'modules/Common/components/Tabs';
import Dropdown from 'modules/Common/components/Dropdown';
import { toSlug } from 'utils';
import { getPropertyFromRoutes } from 'utils/routeUtils';

import { FIXTURES_REFRESH_INTERVAL_MILLIS, MATCH_FILTER_EMPTY_MESSAGE } from 'modules/Football/consts';

require('./FootballFixturesResults.scss');

@layoutAsyncConnect(
  'FootballFixturesResults',
  [
    {
      dispatch: ({params: {date}, routes = []}) => {
        const fixturesResults = getPropertyFromRoutes(routes, 'fixturesResults');

        return loadMatches(date, fixturesResults == "results");
      },
      refreshInterval: FIXTURES_REFRESH_INTERVAL_MILLIS,
      state: state => ({ matches: state.football.dailyMatches.matches }),
      reset: () => resetMatchesLoaded()
    },
    {
      dispatch: () => loadCompetitions(),
      state: state => ({competitions: state.football.competitions.list })
    },
    userServiceLayoutConnect()
  ]
)
@catchLifeCycleErrors
export default class FootballFixturesResults extends Component {
  static propTypes = {
    matches: PropTypes.array.isRequired,
    competitions: PropTypes.array.isRequired,
    params: PropTypes.object,
    routes: PropTypes.array.isRequired,
    fixturesResults: PropTypes.string
  }

  generateTabsForOneWeekEitherSideOfToday(path) {
    let range;

    if (path == "results") {
      range = -7;
    }
    else {
      range = 7;
    }

    return _.range(0, range).map(inc => {
      const thisDate = moment().add(inc, 'days'),
            isIndex = inc === 0;
      const text = localDateShort(thisDate, {convertToday: true});
      let alternatives = [];
      if(isIndex) {
        alternatives = [{href: `/football/${path}/${isoDate(thisDate)}`, isIndex}];
      }

      return {
        href: isIndex ? `/football/${path}` : `/football/${path}/${isoDate(thisDate)}`,
        text,
        isIndex,
        alternatives
      };
    });
  }

  render() {
    const {
      matches = [],
      competitions = [],
      params: {
        date
      } = {},
      routes,
      fixturesResults
    } = this.props;

    let titleBase, title, h1;

    if (fixturesResults === "results") {
      titleBase = "Results";
    }
    else {
      titleBase = "Fixtures";
    }

    if (date) {
      const longDate = localFullDateLong(date);
      h1 = `${titleBase} - ${longDate}`;
      title = `${titleBase} ${longDate}`;
    }
    else {
      title = `Today's ${titleBase}`;
      h1 = titleBase;
    }

    const helmetProps = {
      title,
      ...canonicalLink(routes, { date })
    };

    const competitionOptions = competitions.map(({
      name,
      competition_reference: {
        id: competition_id
       }
      }) => ({
       text: name,
       href: `/football/${fixturesResults}/competitions/${toSlug(name)}/${competition_id}`
      })
    );

    return (
      <div className="footballFixturesResults">
        <MetaDataWrapper helmetProps={helmetProps}/>
        <header>
          <Dropdown title='COMPETITIONS' shouldNavigate={true} options={competitionOptions} className='competitions-dropdown'/>
          <h1>{h1}</h1>
        </header>
        <Tabs tabs={this.generateTabsForOneWeekEitherSideOfToday(fixturesResults)} centerDefault/>
        <FootballMyScores hideIfEmpty={true} matchList={matches}/>
        { matches.length > 0 ?
            <FootballLiveCompetitionList matchList={matches}/>
          :
            <div className="football-live-filter-no-match-msg">
              <p>{MATCH_FILTER_EMPTY_MESSAGE[fixturesResults]}</p>
            </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballFixturesResults.js